import BaseTable from './Table';
import SettingsDecorator from './decorators/settings.decorator';
import DisplayDecorator from './decorators/display.decorator';

export const GridTable = DisplayDecorator(BaseTable);
export const SettingsTable = SettingsDecorator(BaseTable);
export default BaseTable;
